import { GrDivider, palette } from "@jnpmedi/grebob";
import { langHelper } from "@newLibs/utils";
import { usePathname } from "@newHooks/route";
import { NaviItem } from "./NaviItem";
import Style from "./NaviList.styled";
import { NaviListType } from "../../../newLayouts/common/navi";
import { NaviType } from "../../../newLayouts/common/type";

export type NaviListProps = {
  naviItems: NaviListType;
};

export function NaviList({ naviItems }: NaviListProps) {
  const loLang = langHelper.getLang();
  const path = usePathname();

  return (
    <Style.NavWrapper>
      {naviItems
        .filter((item) => !item.isHidden)
        .map((naviItem, index) => {
          if (naviItem.type === NaviType.Divider) {
            return (
              <GrDivider
                key={`divider-${index}`}
                style={{
                  margin: "8px auto",
                  borderColor: naviItem.isVisibleLine ? palette["grey020"] : "transparent",
                  width: "calc(100% - 12px)",
                }}
              />
            );
          }

          if (naviItem.type === NaviType.Navi) {
            return <NaviItem key={`${naviItem.label}-${loLang}`} naviItem={naviItem} isActive={path.startsWith(naviItem.link.url)} />;
          }

          return null;
        })}
    </Style.NavWrapper>
  );
}
